import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import isPast from 'date-fns/is_past';
import differenceInDays from 'date-fns/difference_in_days';

import { DataBlocks, Button, RouterLink, I18n } from 'components';
import { formatUnitString, formatDate } from 'utils/formatString';

import TopupBalance from '@beep/topup-standalone';

import styles from './styles.pcss';

const cx = classNames.bind(styles);
const daysFromNow = (date) => differenceInDays(new Date(), new Date(date));

class PostpaidBalance extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isTopUpWidgetOpen: false,
      paymentMethod: undefined,
    };
  }

  setIsTopUpWidgetOpen = (isOpen, isSBP) => {
    this.setState({
      isTopUpWidgetOpen: isOpen,
      paymentMethod: isSBP ? 'sbp' : undefined,
    });
  }

  render() {
    const {
      debt,
      invoices,
      currency,
      settings: { ctn },
    } = this.props;

    const { isTopUpWidgetOpen, paymentMethod } = this.state;

    if (!invoices || !debt) {
      return null;
    }

    let overdue = 0;
    let toPay = 0;

    invoices.sort((a, b) => daysFromNow(b.dueDate) - daysFromNow(a.dueDate));

    invoices.forEach((invoice) => {
      toPay += invoice.unpaidAmt;
      if (isPast(new Date(invoice.dueDate))) {
        overdue += invoice.unpaidAmt;
      }
    });

    return (
      <DataBlocks.Block
        className={['halfWidth', { alert: overdue }, cx('container')]}
        title={<I18n path="home.postpaidBalance.title" />}
      >
        <TopupBalance
          isOpen={isTopUpWidgetOpen}
          sum={debt}
          accountNumber={ctn}
          prefilledAccountNumber={ctn}
          setIsOpen={(isOpen) => {
            this.setIsTopUpWidgetOpen(isOpen);
          }}
          paymentMethod={paymentMethod}
        />
        <div className={cx('balance')}>
          {formatUnitString(-debt.balance, debt.currency)}
        </div>

        {invoices.length ? (
          <div className={cx('invoices')}>
            <div className={cx('row')}>
              <I18n
                className={cx('label')}
                path="home.postpaidBalance.toPay"
              />
              <span className={cx('value')}>
                {formatUnitString(toPay, currency)}
              </span>
            </div>
            {overdue > 0 && (
              <div className={cx('row', 'overdueRow')}>
                <I18n
                  className={cx('label')}
                  path="home.postpaidBalance.overdue"
                />
                <span className={cx('value')}>
                  {formatUnitString(overdue, currency)}
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className={cx('message')}>
            <I18n path="home.postpaidBalance.noInvoices" />
          </div>
        )}

        {overdue > 0 && (
          <div className={cx('message')}>
            <I18n path="home.postpaidBalance.overdueAlert" />
          </div>
        )}

        {overdue === 0 && invoices.length > 0 && (
          <div className={cx('message')}>
            <I18n
              path="home.postpaidBalance.invoicesDate"
              vars={{ date: formatDate(invoices[0].dueDate) }}
            />
          </div>
        )}
        <div className={cx('links')}>
          <Button
            className={cx('button')}
            onClick={() => {
              this.setIsTopUpWidgetOpen(true);
            }}
          >
            <I18n path="home.postpaidBalance.toPay" />
          </Button>
          {invoices.length > 0 && (
          <RouterLink to="/detalization">
            <I18n path="home.postpaidBalance.invoicesLink" />
          </RouterLink>
          )}
        </div>
      </DataBlocks.Block>
    );
  }
}

function mapStateToProps(state) {
  const balance = state.home.balance.data;
  const { settings } = state.application;

  return {
    debt: balance && balance.debt,
    invoices: balance && balance.invoices,
    currency: balance && balance.currency,
    paymentUrl: balance && balance.paymentUrl,
    settings,
  };
}

PostpaidBalance.propTypes = {
  debt: PropTypes.object,
  invoices: PropTypes.array,
  currency: PropTypes.string,
  settings: PropTypes.object,
};

export default connect(mapStateToProps)(PostpaidBalance);
